import React, { useContext } from "react"
import Button from "./Button"
import { GlobalDispatchContext } from "../context/GlobalContextProvider"

import { GA4Event } from "../utils/Analytics"

const CtaButton = ({
  productCode,
  product_code,
  className,
  children,
  repo,
  nameModule,
  onClick,
  ...others
}) => {
  const dispatch = useContext(GlobalDispatchContext)
  const handleClick = () => {
    if (productCode) {
      let tracking = {
        ecommerce: {
          im_collection_name_event:
            others?.trackingObj?.product_info?.product_universal_title,
          im_type: "subscription",
          im_module_name: "virtual_page",
          im_module_detail: nameModule || "",
          im_cta_type: others?.trackingAction || "",
        },
      }
      window.snakeAnalytics = window.snakeAnalytics || []
      window.snakeAnalytics.push(["event", "cta_subscription", tracking])
    }

    //HOTFIX 26-07
    if (others.forceOverrideLinkTEMPORARY) {
      let pc = productCode || product_code
      if (!pc) {
        const arr = others.forceOverrideLinkTEMPORARY.split("?product-code=")
        if (arr.length === 2) {
          pc = arr[1]
        }
      }
      dispatch({
        type: "toggleCta",
        payload: {
          productCode: pc,
          force: others.forceOverrideLinkTEMPORARY,
          productVersion:
            others?.trackingObj?.product_info?.product_version ?? "00",
        },
      })
    } else {
      dispatch({
        type: "toggleCta",
        payload: {
          productCode: productCode || product_code,
          productVersion:
            others?.trackingObj?.product_info?.product_version ?? "00",
        },
      })
    }
  }
  //HOTFIX 26-07
  const { href, ...extras } = others
  const othersToPass = others.forceOverrideLinkTEMPORARY ? extras : others
  return (
    <Button
      className={className}
      onClick={onClick || handleClick}
      {...othersToPass}
      trackingObj={others.trackingObj}
      trackingAction={others.trackingAction}
      trackingLabel={others.trackingLabel}
    >
      {children || others?.title}
    </Button>
  )
}

export default CtaButton
